/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StatusRouteImport } from './routes/status'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TeacherIndexRouteImport } from './routes/teacher.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as TeacherSubmissionsRouteImport } from './routes/teacher.submissions'
import { Route as TeacherProfileRouteImport } from './routes/teacher.profile'
import { Route as TeacherHistoryRouteImport } from './routes/teacher.history'
import { Route as LoginTeacherRouteImport } from './routes/login.teacher'
import { Route as LoginAdminRouteImport } from './routes/login.admin'
import { Route as AdminTeachersRouteImport } from './routes/admin.teachers'
import { Route as AdminSubmissionsRouteImport } from './routes/admin.submissions'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as AdminProfileRouteImport } from './routes/admin.profile'
import { Route as AdminExportsRouteImport } from './routes/admin.exports'
import { Route as TeacherVerifyIdRouteImport } from './routes/teacher.verify.$id'

const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherIndexRoute = TeacherIndexRouteImport.update({
  id: '/teacher/',
  path: '/teacher/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherSubmissionsRoute = TeacherSubmissionsRouteImport.update({
  id: '/teacher/submissions',
  path: '/teacher/submissions',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherProfileRoute = TeacherProfileRouteImport.update({
  id: '/teacher/profile',
  path: '/teacher/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherHistoryRoute = TeacherHistoryRouteImport.update({
  id: '/teacher/history',
  path: '/teacher/history',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginTeacherRoute = LoginTeacherRouteImport.update({
  id: '/login/teacher',
  path: '/login/teacher',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginAdminRoute = LoginAdminRouteImport.update({
  id: '/login/admin',
  path: '/login/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTeachersRoute = AdminTeachersRouteImport.update({
  id: '/admin/teachers',
  path: '/admin/teachers',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSubmissionsRoute = AdminSubmissionsRouteImport.update({
  id: '/admin/submissions',
  path: '/admin/submissions',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/admin/reports',
  path: '/admin/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProfileRoute = AdminProfileRouteImport.update({
  id: '/admin/profile',
  path: '/admin/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminExportsRoute = AdminExportsRouteImport.update({
  id: '/admin/exports',
  path: '/admin/exports',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherVerifyIdRoute = TeacherVerifyIdRouteImport.update({
  id: '/teacher/verify/$id',
  path: '/teacher/verify/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/status': typeof StatusRoute
  '/admin/exports': typeof AdminExportsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/teachers': typeof AdminTeachersRoute
  '/login/admin': typeof LoginAdminRoute
  '/login/teacher': typeof LoginTeacherRoute
  '/teacher/history': typeof TeacherHistoryRoute
  '/teacher/profile': typeof TeacherProfileRoute
  '/teacher/submissions': typeof TeacherSubmissionsRoute
  '/admin/': typeof AdminIndexRoute
  '/teacher/': typeof TeacherIndexRoute
  '/teacher/verify/$id': typeof TeacherVerifyIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/status': typeof StatusRoute
  '/admin/exports': typeof AdminExportsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/teachers': typeof AdminTeachersRoute
  '/login/admin': typeof LoginAdminRoute
  '/login/teacher': typeof LoginTeacherRoute
  '/teacher/history': typeof TeacherHistoryRoute
  '/teacher/profile': typeof TeacherProfileRoute
  '/teacher/submissions': typeof TeacherSubmissionsRoute
  '/admin': typeof AdminIndexRoute
  '/teacher': typeof TeacherIndexRoute
  '/teacher/verify/$id': typeof TeacherVerifyIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/status': typeof StatusRoute
  '/admin/exports': typeof AdminExportsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/teachers': typeof AdminTeachersRoute
  '/login/admin': typeof LoginAdminRoute
  '/login/teacher': typeof LoginTeacherRoute
  '/teacher/history': typeof TeacherHistoryRoute
  '/teacher/profile': typeof TeacherProfileRoute
  '/teacher/submissions': typeof TeacherSubmissionsRoute
  '/admin/': typeof AdminIndexRoute
  '/teacher/': typeof TeacherIndexRoute
  '/teacher/verify/$id': typeof TeacherVerifyIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/status'
    | '/admin/exports'
    | '/admin/profile'
    | '/admin/reports'
    | '/admin/submissions'
    | '/admin/teachers'
    | '/login/admin'
    | '/login/teacher'
    | '/teacher/history'
    | '/teacher/profile'
    | '/teacher/submissions'
    | '/admin/'
    | '/teacher/'
    | '/teacher/verify/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/status'
    | '/admin/exports'
    | '/admin/profile'
    | '/admin/reports'
    | '/admin/submissions'
    | '/admin/teachers'
    | '/login/admin'
    | '/login/teacher'
    | '/teacher/history'
    | '/teacher/profile'
    | '/teacher/submissions'
    | '/admin'
    | '/teacher'
    | '/teacher/verify/$id'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/status'
    | '/admin/exports'
    | '/admin/profile'
    | '/admin/reports'
    | '/admin/submissions'
    | '/admin/teachers'
    | '/login/admin'
    | '/login/teacher'
    | '/teacher/history'
    | '/teacher/profile'
    | '/teacher/submissions'
    | '/admin/'
    | '/teacher/'
    | '/teacher/verify/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  StatusRoute: typeof StatusRoute
  AdminExportsRoute: typeof AdminExportsRoute
  AdminProfileRoute: typeof AdminProfileRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminSubmissionsRoute: typeof AdminSubmissionsRoute
  AdminTeachersRoute: typeof AdminTeachersRoute
  LoginAdminRoute: typeof LoginAdminRoute
  LoginTeacherRoute: typeof LoginTeacherRoute
  TeacherHistoryRoute: typeof TeacherHistoryRoute
  TeacherProfileRoute: typeof TeacherProfileRoute
  TeacherSubmissionsRoute: typeof TeacherSubmissionsRoute
  AdminIndexRoute: typeof AdminIndexRoute
  TeacherIndexRoute: typeof TeacherIndexRoute
  TeacherVerifyIdRoute: typeof TeacherVerifyIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher/': {
      id: '/teacher/'
      path: '/teacher'
      fullPath: '/teacher/'
      preLoaderRoute: typeof TeacherIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher/submissions': {
      id: '/teacher/submissions'
      path: '/teacher/submissions'
      fullPath: '/teacher/submissions'
      preLoaderRoute: typeof TeacherSubmissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher/profile': {
      id: '/teacher/profile'
      path: '/teacher/profile'
      fullPath: '/teacher/profile'
      preLoaderRoute: typeof TeacherProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher/history': {
      id: '/teacher/history'
      path: '/teacher/history'
      fullPath: '/teacher/history'
      preLoaderRoute: typeof TeacherHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/teacher': {
      id: '/login/teacher'
      path: '/login/teacher'
      fullPath: '/login/teacher'
      preLoaderRoute: typeof LoginTeacherRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/admin': {
      id: '/login/admin'
      path: '/login/admin'
      fullPath: '/login/admin'
      preLoaderRoute: typeof LoginAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/teachers': {
      id: '/admin/teachers'
      path: '/admin/teachers'
      fullPath: '/admin/teachers'
      preLoaderRoute: typeof AdminTeachersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/submissions': {
      id: '/admin/submissions'
      path: '/admin/submissions'
      fullPath: '/admin/submissions'
      preLoaderRoute: typeof AdminSubmissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/admin/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/profile': {
      id: '/admin/profile'
      path: '/admin/profile'
      fullPath: '/admin/profile'
      preLoaderRoute: typeof AdminProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/exports': {
      id: '/admin/exports'
      path: '/admin/exports'
      fullPath: '/admin/exports'
      preLoaderRoute: typeof AdminExportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher/verify/$id': {
      id: '/teacher/verify/$id'
      path: '/teacher/verify/$id'
      fullPath: '/teacher/verify/$id'
      preLoaderRoute: typeof TeacherVerifyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  StatusRoute: StatusRoute,
  AdminExportsRoute: AdminExportsRoute,
  AdminProfileRoute: AdminProfileRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminSubmissionsRoute: AdminSubmissionsRoute,
  AdminTeachersRoute: AdminTeachersRoute,
  LoginAdminRoute: LoginAdminRoute,
  LoginTeacherRoute: LoginTeacherRoute,
  TeacherHistoryRoute: TeacherHistoryRoute,
  TeacherProfileRoute: TeacherProfileRoute,
  TeacherSubmissionsRoute: TeacherSubmissionsRoute,
  AdminIndexRoute: AdminIndexRoute,
  TeacherIndexRoute: TeacherIndexRoute,
  TeacherVerifyIdRoute: TeacherVerifyIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

